import { SearchQuery } from "../code/search-query/search-query";
import ManagedGridView from "../controls/ManagedGridView";
import {
  categoriesViewColumns,
  mapCategoriesViewQuery,
} from "./CategoriesView.default";
import { getCategories } from "../repository/data.repository";
import { ContentType } from "../repository/data.default";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";
import { createGridRequest } from "../hooks/useGridRequest";
import { enumRequest } from "../utils/options";

export interface CategoriesViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function CategoriesView(props: CategoriesViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={categoriesViewColumns}
      mapQuery={mapCategoriesViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getCategories, { retry: true })}
      pageSize={100}
      schema={{
        groups: [
          {
            controls: [
              { type: "textbox", name: "name", label: "Name" },
              { type: "textbox", name: "code", label: "Code" },
              { type: "textbox", name: "description", label: "Description" },
              {
                type: "combobox",
                name: "contentType",
                label: "Content Type",
                request: enumRequest(ContentType),
              },
            ],
          },
        ],
      }}
      actions={(record) => [
        {
          key: "update",
          label: "Edit",
          disabled: !permissions.can("TemplatesCategories", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          disabled: !permissions.can("TemplatesCategories", "delete"),
          danger: true,
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default CategoriesView;
